// extracted by mini-css-extract-plugin
module.exports = {"c-popular-tabs":"_025a50318d--c-popular-tabs--2DNPd"};